import { paths } from "src/paths";
import type { ServicePlanCardData } from "src/sections/pricing/service-plan-card";

export const HOSTED_NIGHTSCOUT_DETAILS: string[] = [
  "Ready within an hour",
  "24/7 WhatsApp Helpdesk",
  "Pay with Credit Card, Google Pay, Ideal, Bancontact or SEPA debit",
  "Database import/export",
  "Nightscout version latest version",
  "Expandable storage",
  "Cloud Builder for loop apps (AndroidAPS, Trio and iLoop)",
  "Connect Nightscout with LibreLinkUp (not recommended for loopers)",
  "Nightscout to Nightscout data transfer",
  "Additional data visualization tools",
  "Free cancellation anytime",
];

// Temporarily hidden: Hosted Nightscout Extra (Glucose Chat).
// export const HOSTED_NIGHTSCOUT_GLUCOSE_CHAT_DETAILS: string[] = [
//   "Connect your data with an AI powered chat about your diabetes",
//   "Personalized summaries via Email",
//   "Add family members, friends and caregivers to your email list",
//   "All features of Hosted Nightscout",
// ];

export const hostedNightscoutPlans: ServicePlanCardData[] = [
  {
    id: "technology",
    category: "Technology",
    title: "Hosted Nightscout",
    description: "Hosted Nightscout in three easy steps",
    price: "",
    details: HOSTED_NIGHTSCOUT_DETAILS,
    buttonText: "Get started",
    buttonVariant: "contained",
    illustrationBg: "#DBEAFE",
    link: paths.auth.firebase.login,
    billingPlan: "hosted",
    badge: "nen",
  },
  // Temporarily hidden: Hosted Nightscout Extra.
  // {
  //   id: "technology-aichat",
  //   category: "Technology",
  //   title: "Hosted Nightscout Extra",
  //   description: "Nightscout, Glucose Chat and Messaging (Beta)",
  //   price: "",
  //   details: HOSTED_NIGHTSCOUT_GLUCOSE_CHAT_DETAILS,
  //   buttonText: "Get started",
  //   buttonVariant: "outlined",
  //   illustrationBg: "#E0E7FF",
  //   link: paths.auth.firebase.login,
  //   billingPlan: "hosted-aichat",
  //   badge: "nen",
  // },
];
